<template>
  <div id="app">
    <a-layout>
      <a-layout-header v-if="user">
        <img src="@/assets/logo.svg" alt="Leads Manager" class="logo" />
        <router-link to="/forms">Forms</router-link>
        <a-divider type="vertical"></a-divider>
        <router-link to="/country-errors" v-if="isAdminUser">Country Errors</router-link>
        <a-divider type="vertical"></a-divider>
        <router-link to="/show-batch-history" v-if="isAdminUser">Batch History</router-link>
        <a-divider type="vertical" v-if="isAdminUser"></a-divider>
        <router-link to="/add-form">Add New Form</router-link>
        <div class="spacer"></div>
        <router-link to="/manage-users" v-if="isAdminUser">Users</router-link>
        <a-divider type="vertical" v-if="isAdminUser"></a-divider>
        <router-link to="/manage-lookups" v-if="isAdminUser">Questions/Countries</router-link>
        <a-divider type="vertical" v-if="isAdminUser"></a-divider>
        <amplify-sign-out></amplify-sign-out>
      </a-layout-header>
      <a-layout-content>
        <router-view />
      </a-layout-content>
      <footer>{{ts}}</footer>
    </a-layout>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["isAdminUser"]),
    ...mapState(["user"])
  },
  data() {
    return {
      ts: document.documentElement.dataset.buildTs
    };
  },
  name: "app"
};
</script>
<style lang="scss">
@import "./assets/scss/main.scss";
#app {
  text-align: center;
}
.ant-layout-header {
  background-color: #fff;
  display: flex;
  align-items: center;
  line-height: 62px;

  a {
    font-size: 20px;
    display: inline-block;
    border-bottom: solid 2px #fff;

    &:focus {
      text-decoration: none;
    }

    &.router-link-exact-active {
      border-color: #1890ff;
    }
  }
}
.logo {
  max-height: 40px;
  margin-right: 20px;
}
.spacer {
  flex-grow: 1;
}
.ant-layout-content {
  background-color: #fff;
  padding: 50px;
  text-align: left;
  min-height: 90vh;

  @media (max-width: 500px) {
    padding: 10vw;
  }
}
footer {
  padding: 20px;
  font-size: 12px;
  color: #999;
  text-align: right;
}
</style>
